import React, { useState } from 'react';
import AddressFormFields from '../../../theme/components/AddressFormFields.tsx/AddressFormFields';
import { useAdaptableParams } from '../../../../../util/hooks/useAdaptableParams';
import { useFormik } from 'formik';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../redux/store.model';
import { isEqual } from 'lodash';
import { getDeviceDataById } from '../../../../../redux/commander/selectors';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { getPolyglot } from '../../../../../i18n';
import { putDevice } from '../../../../../redux/commander/actions/thunks';
import { DeviceDataAPIResponse } from '../../../../../redux/commander/api/device.model';
import { useShowErrorMessage, useShowMessage } from '../../../../../util/hooks';
const FWDeviceSettingsPage = () => {
  const params = useAdaptableParams<{
    groupId: string;
    merchandiserId: string;
  }>();
  const { merchandiserId = '' } = params;
  const polyglot = getPolyglot();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const device = useAppSelector(
    (state) => getDeviceDataById(state, { deviceId: merchandiserId }),
    isEqual
  );
  const dispatch = useAppDispatch();
  const showMessage = useShowMessage();
  const showErrorMessage = useShowErrorMessage();

  const formik = useFormik({
    initialValues: {
      zipCode: device?.zipcode || '',
      city: device?.city || '',
      street: device?.street || '',
      country: device?.country || '',
    },

    onSubmit: async (values) => {
      formik.setTouched({
        zipCode: true,
        city: true,
        street: true,
        country: true,
      });
      if (!formik.isValid) return;

      setIsSubmitting(true);
      try {
        await dispatch(
          putDevice(merchandiserId, {
            ...device,
            zipcode: values.zipCode,
            city: values.city,
            street: values.street,
            country: values.country,
          } as DeviceDataAPIResponse)
        );
        showMessage(polyglot.t('composable_device.save_successful_message'));
      } catch (error) {
        showErrorMessage(polyglot.t('device.settings.update_error_message'));
        return error;
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2} direction="column" sx={{ paddingBottom: '2rem' }}>
        <AddressFormFields formik={formik} />
        <Box
          display="flex"
          gap="1rem"
          justifyContent="flex-end"
          width="100%"
          paddingTop={2}
        >
          <Button
            type="submit"
            onClick={() => formik.handleSubmit()}
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            autoFocus={true}
          >
            {isSubmitting ? (
              <CircularProgress size={24} />
            ) : (
              polyglot.t('button.save')
            )}
          </Button>
        </Box>
      </Stack>
    </form>
  );
};

export default FWDeviceSettingsPage;
